type Listener = () => void;

let suppressed = false;
const listeners = new Set<Listener>();

export function setStickyFooterBannerSuppressed(value: boolean): void {
  if (suppressed === value) return;
  suppressed = value;
  listeners.forEach((listener) => listener());
}

export function getStickyFooterBannerSuppressed(): boolean {
  return suppressed;
}

export function subscribeStickyFooterBannerSuppressed(
  listener: Listener
): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function resetStickyFooterBannerSuppressed(): void {
  setStickyFooterBannerSuppressed(false);
}
